import moment from "moment";
import Vue from "vue";
 
Vue.filter('yesNo', function(value: string) {  
    return value?'да':'нет';
})
